export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8860.d578827c.jpg";